import { Card, CardBody, Col, Form, Row } from "reactstrap";
import { Btn, Image, LI, UL } from "../../../../AbstractElements";
import { Emi, FirstName, LastName, Pincode, Submit } from "../../../../Constants/Constants";
import { dynamicImage } from "../../../../Utils";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import FormGroupCommon from "./Common/FormGroupCommon";
import SelectCommon from "./Common/SelectCommon";

const EmiForm = () => {
  const EmiBankSelect: string[] = ["Bank Name", "SBI", "ICICI", "KOTAK", "BOB"];
  const EmiCardSelect: string[] = ["Select Card", "2", "3", "4", "5"];
  const EmiYearSelect: string[] = ["Select Duration", "2015-2016", "2016-2017", "2017-2023", "2023-2019"];

  return (
    <Col xxl="4" lg="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={Emi} />
        <CardBody>
          <Form className="theme-form" onSubmit={(e) => e.preventDefault()}>
            <Row>
              <FormGroupCommon type="text" placeholder={FirstName} formClass="col-6 p-r-0" />
              <FormGroupCommon type="text" placeholder={LastName} formClass="col-6" />
              <FormGroupCommon type="text" placeholder={Pincode} formClass="col-6 p-r-0" />
              <SelectCommon size={1} data={EmiBankSelect} selectClass="col-6" />
              <SelectCommon size={1} data={EmiCardSelect} selectClass="col-12" />
              <SelectCommon size={1} data={EmiYearSelect} selectClass="col-12" />
              <Col xs="12" className="mb-3">
                <UL className="payment-opt simple-list flex-row">
                  <LI><Image src={dynamicImage(`ecommerce/mastercard.png`)} alt="" /></LI>
                  <LI><Image src={dynamicImage(`ecommerce/visa.png`)} alt="" /></LI>
                  <LI><Image src={dynamicImage(`ecommerce/paypal.png`)} alt="" /></LI>
                </UL>
              </Col>
              <Col xs="12">
                <Btn color="primary">{Submit}</Btn>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default EmiForm;
